/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  0% {\n    left: -35%;\n    right: 100%;\n  }\n\n  60% {\n    left: 100%;\n    right: -90%;\n  }\n\n  100% {\n    left: 100%;\n    right: -90%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n        animation: ",
        " 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;\n      "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal._([
        "\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal._([
        "\n        animation: ",
        " 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;\n      "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal._([
        "\n  0% {\n    opacity: 1;\n    background-position: 0 -23px;\n  }\n\n  60% {\n    opacity: 0;\n    background-position: 0 -23px;\n  }\n\n  100% {\n    opacity: 1;\n    background-position: -200px -23px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal._([
        "\n        animation: ",
        " 3s infinite linear;\n      "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _colorManipulator = require("@mui/system/colorManipulator");
var _RtlProvider = require("@mui/system/RtlProvider");
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _linearProgressClasses = require("./linearProgressClasses");
var _jsxRuntime = require("react/jsx-runtime");
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0, _zeroStyled.keyframes)(_templateObject());
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const indeterminate1Animation = typeof indeterminate1Keyframe !== 'string' ? (0, _zeroStyled.css)(_templateObject1(), indeterminate1Keyframe) : null;
const indeterminate2Keyframe = (0, _zeroStyled.keyframes)(_templateObject2());
const indeterminate2Animation = typeof indeterminate2Keyframe !== 'string' ? (0, _zeroStyled.css)(_templateObject3(), indeterminate2Keyframe) : null;
const bufferKeyframe = (0, _zeroStyled.keyframes)(_templateObject4());
const bufferAnimation = typeof bufferKeyframe !== 'string' ? (0, _zeroStyled.css)(_templateObject5(), bufferKeyframe) : null;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color } = ownerState;
    const slots = {
        root: [
            'root',
            "color".concat((0, _capitalize.default)(color)),
            variant
        ],
        dashed: [
            'dashed',
            "dashedColor".concat((0, _capitalize.default)(color))
        ],
        bar1: [
            'bar',
            'bar1',
            "barColor".concat((0, _capitalize.default)(color)),
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && "barColor".concat((0, _capitalize.default)(color)),
            variant === 'buffer' && "color".concat((0, _capitalize.default)(color)),
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, _composeClasses.default)(slots, _linearProgressClasses.getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color)=>{
    if (theme.vars) {
        return theme.vars.palette.LinearProgress["".concat(color, "Bg")];
    }
    return theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles["color".concat((0, _capitalize.default)(ownerState.color))],
            styles[ownerState.variant]
        ];
    }
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    return {
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map((param)=>{
                let [color] = param;
                return {
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: getColorShade(theme, color)
                    }
                };
            }),
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.color === 'inherit' && ownerState.variant !== 'buffer';
                },
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    };
}));
const LinearProgressDashed = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.dashed,
            styles["dashedColor".concat((0, _capitalize.default)(ownerState.color))]
        ];
    }
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map((param)=>{
                let [color] = param;
                const backgroundColor = getColorShade(theme, color);
                return {
                    props: {
                        color
                    },
                    style: {
                        backgroundImage: "radial-gradient(".concat(backgroundColor, " 0%, ").concat(backgroundColor, " 16%, transparent 42%)")
                    }
                };
            })
        ]
    };
}), bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: "".concat(bufferKeyframe, " 3s infinite linear")
});
const LinearProgressBar1 = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles["barColor".concat((0, _capitalize.default)(ownerState.color))],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map((param)=>{
                let [color] = param;
                return {
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                };
            }),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: "transform .".concat(TRANSITION_DURATION, "s linear")
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: "transform .".concat(TRANSITION_DURATION, "s linear")
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
                },
                style: indeterminate1Animation || {
                    animation: "".concat(indeterminate1Keyframe, " 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite")
                }
            }
        ]
    };
}));
const LinearProgressBar2 = (0, _zeroStyled.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles["barColor".concat((0, _capitalize.default)(ownerState.color))],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map((param)=>{
                let [color] = param;
                return {
                    props: {
                        color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                };
            }),
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.variant !== 'buffer' && ownerState.color !== 'inherit';
                },
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.variant !== 'buffer' && ownerState.color === 'inherit';
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map((param)=>{
                let [color] = param;
                return {
                    props: {
                        color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: getColorShade(theme, color),
                        transition: "transform .".concat(TRANSITION_DURATION, "s linear")
                    }
                };
            }),
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.variant === 'indeterminate' || ownerState.variant === 'query';
                },
                style: indeterminate2Animation || {
                    animation: "".concat(indeterminate2Keyframe, " 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite")
                }
            }
        ]
    };
}));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const LinearProgress = /*#__PURE__*/ React.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className, color = 'primary', value, valueBuffer, variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color,
        variant
    };
    const classes = useUtilityClasses(ownerState);
    const isRtl = (0, _RtlProvider.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) {
                transform = -transform;
            }
            inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
        } else if ("production" !== 'production') {
            console.error('MUI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) {
                transform = -transform;
            }
            inlineStyles.bar2.transform = "translateX(".concat(transform, "%)");
        } else if ("production" !== 'production') {
            console.error('MUI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LinearProgressRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
"production" !== "production" ? LinearProgress.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'inherit',
            'primary',
            'secondary'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */ value: _propTypes.default.number,
    /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */ valueBuffer: _propTypes.default.number,
    /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */ variant: _propTypes.default.oneOf([
        'buffer',
        'determinate',
        'indeterminate',
        'query'
    ])
} : void 0;
var _default = exports.default = LinearProgress;
